import type { Component } from "react"

import type { Loading } from "@/lib/loading"
import { dependenciesReady } from "@/lib/loading/dependenciesReady"
import { processIsReady } from "@/lib/loading/processIsReady"

export const curryOnMaybeReady = <
  Props extends { loading: Loading.ContextData },
  State extends { loadingConfig: Loading.Config }
>(
  component: Component<Props, State>,
  {
    onDependenciesResolved,
    onLoaded,
  }: {
    onDependenciesResolved?: () => Promise<void> | void
    onLoaded?: () => Promise<void> | void
  }
): Loading.Functions.OnMaybeReady => {
  return async (): Promise<Loading.StillLoading> => {
    const { loadingConfig } = component.state

    if (loadingConfig.readying) {
      return true
    }

    if (
      processIsReady(component.props, component.state.loadingConfig.processId)
    ) {
      return false
    }

    if (!dependenciesReady(component.props, component.state.loadingConfig)) {
      return true
    }

    component.setState({
      loadingConfig: {
        ...loadingConfig,
        readying: true,
      },
    })

    if (onDependenciesResolved) {
      await onDependenciesResolved()
    }

    component.props.loading.update({
      [loadingConfig.processId]: {
        loading: false,
      },
    })

    if (onLoaded) {
      await onLoaded()
    }

    component.setState({
      loadingConfig: {
        ...loadingConfig,
        readying: false,
      },
    })

    return true
  }
}
